import apiClient from '../axios.js';

export const stampCampaignService = {
  getCampaigns: async (params = {}) => {
    const response = await apiClient.get('/admin/stamp-campaigns', { params });
    return response;
  },

  getCampaign: async (id) => {
    const response = await apiClient.get(`/admin/stamp-campaigns/${id}`);
    return response;
  },

  createCampaign: async (payload) => {
    const response = await apiClient.post('/admin/stamp-campaigns', payload);
    return response;
  },

  updateCampaign: async (id, payload) => {
    const response = await apiClient.put(`/admin/stamp-campaigns/${id}`, payload);
    return response;
  },

  deleteCampaign: async (id) => {
    const response = await apiClient.delete(`/admin/stamp-campaigns/${id}`);
    return response;
  },

  getParticipants: async (campaignId, params = {}) => {
    const response = await apiClient.get(`/admin/stamp-campaigns/${campaignId}/participants`, { params });
    return response;
  },

  getStatistics: async (campaignId, params = {}) => {
    const response = await apiClient.get(`/admin/stamp-campaigns/${campaignId}/stats`, { params });
    return response;
  },

  getRecords: async (campaignId, params = {}) => {
    const response = await apiClient.get(`/admin/stamp-campaigns/${campaignId}/records`, { params });
    return response;
  },

  manualIssue: async (campaignId, payload) => {
    const response = await apiClient.post(`/admin/stamp-campaigns/${campaignId}/issue`, payload);
    return response;
  },

  getQrIssueInfo: async (campaignId) => {
    const response = await apiClient.get(`/admin/stamp-campaigns/${campaignId}/qr-issue`);
    return response;
  },

  uploadImage: async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await apiClient.post('/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response;
  }
};
